import { Stepper, StepperProps } from "app/core/components/Stepper"

export const steps: StepperProps["steps"] = [
  {
    label: "Student Info",
    href: (params) => `/book-testing/homeschool/${params.orderId}/1`,
  },
  {
    label: "Schedule Tests",
    href: (params) => `/book-testing/homeschool/${params.orderId}/2`,
  },
  {
    label: "Billing & Checkout",
    href: (params) => `/book-testing/homeschool/${params.orderId}/3`,
  },
]

export const HomeschoolStepper = () => {
  return <Stepper steps={steps} />
}
